module.exports = __webpack_public_path__ + "img/5-1.0424d4cb.png";